module.exports = __webpack_public_path__ + "static/img/pic-03@2x.257aed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-03@2x.png
// module id = 3SEp
// module chunks = 1